import { z } from 'zod'

/**
 * How round an organization's signer pages and signer email are: `medium` is
 * PixelSign's own (6px controls, 8px cards, 12px dialogs); `none` is square,
 * and `small` and `large` go either way. The design system maps each to its
 * radius tokens (design-system/tokens.css, `[data-radius]`).
 */
export const CORNER_RADII = ['none', 'small', 'medium', 'large'] as const

export const cornerRadiusSchema = z.enum(CORNER_RADII)

export type CornerRadius = z.infer<typeof cornerRadiusSchema>

/** A stored value as a corner radius, PixelSign's for anything unknown. */
export const storedCornerRadiusSchema = cornerRadiusSchema.catch('medium')
